import { combineReducers } from 'redux'

import isDialogOpen from './isDialogOpen'
import conflictingAIObjects from './conflictingAIObjects'

export default combineReducers({
  isDialogOpen,
  conflictingAIObjects,
})
